module.exports = __webpack_public_path__ + "img/ico-research.f3689764.svg";